import Breadcrumb from "../components/Breadcrumb";
import TaxTypesLayer from "../components/TaxTypesLayer";

const TaxTypespage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Tax Types" />

      < TaxTypesLayer/>
    </>
  );
};

export default TaxTypespage;
